import store from '../store'
import practiceService from '@/services/practices/practiceServices.js'
import axios from 'axios'
import qs from 'qs'
import {
    getCookie
} from './CookieReciever.js'
import {checkforReadyStepsCoach} from 'src/util/ReadyStepsCheck'

/*
This function creates and returns an object that holds the parameters nessesary for logging a user into the old practice dashboard
*/
async function getDefaultRequestData(destination) {
    // Get practice data to set relevant practice session variables
    var practice = store.getters["currentUser/getCurrentUsersPractice"]
    // check for ready steps
    if (destination == '../method_sph_coach/CLIENT_VIEW.ASP' || destination == '../include/new_dash_tracker.asp' || destination == '../include/new_dash_planner.asp') {
        if(checkforReadyStepsCoach() == true) {
            practice = store.getters["pinnedUser/getPinnedUsersPractice"]
        }
    }
    var practiceDataPromise = await practiceService.getCurrentPractice(practice)
    var practiceData = practiceDataPromise?.result
    var hostname = window.location.hostname
    var superpractice
    if (hostname.includes('trackmyday')) {
        superpractice = 'www.trackmyday.org'
    } else {
        superpractice = 'www.setpointhealth.com'
    }
    var requestData = {
        NewAdminJWTToken: store.getters['currentUser/getAuthToken'],
        CSRFToken: getCookie('xcsrf_token'),
        SPH_CONTEXT_LOGIN: store.getters['pinnedUser/isUserPinned'] ? store.getters['pinnedUser/getPinnedUsersLogin'] : '',
        SPH_CONTEXT_NAME: store.getters['pinnedUser/isUserPinned'] ? store.getters['pinnedUser/getPinnedUsersName'] : '',
        tab_login: store.getters['pinnedUser/isUserPinned'] ? store.getters['pinnedUser/getPinnedUsersLogin'] : '',
        SPH_login: store.getters['currentUser/getCurrentUsersLogin'],
        SPH_NAME: store.getters['currentUser/getCurrentUsersFirstName'],
        SPH_PRACTICE: practice,
        SPH_PRACTICE_TYPE: practiceData?.practice_type,
        SPH_SHORTCODE: practiceData?.shortcode,
        SPH_NEW_SITE: practiceData?.new_site,
        SPH_TIMEZONE_OFFSET: practiceData?.default_time_zone,
        SPH_COMPONENTS_LIST: practiceData?.components,
        SPH_METRIC1: practiceData?.metric1,
        SPH_METRIC2: practiceData?.metric2,
        SPH_METRIC3: practiceData?.metric3,
        SPH_METRIC4: practiceData?.metric4,
        SPH_METRIC5: practiceData?.metric5,
        SPH_METRIC6: practiceData?.metric6,
        SPH_METRIC7: practiceData?.metric7,
        SPH_METRIC8: practiceData?.metric8,
        SPH_METRIC9: practiceData?.metric9,
        SPH_METRIC10: practiceData?.metric10,
        SPH_METRIC11: practiceData?.metric11,
        SPH_METRIC12: practiceData?.metric12,
        SPH_METRIC13: practiceData?.metric13,
        SPH_METRIC14: practiceData?.metric14,
        SPH_SUPER_PRACTICE: superpractice,
        SPH_MASTER_PRACTICE: hostname,
        USING_NEW_DASHBOARD: 'true',
        zthis_login: store.getters['currentUser/getCurrentUsersLogin'],
        this_name: store.getters['currentUser/getCurrentUsersFirstName'],
        this_username: store.getters['currentUser/getCurrentUsersLogin'],
        zthis_practice: practice,
    }
    return requestData
}

async function getLogoutRequestData() {
    var requestData = {
        NewAdminJWTToken: '',
        CSRFToken: '',
        SPH_CONTEXT_LOGIN: '',
        SPH_CONTEXT_NAME: '',
        tab_login: '',
        SPH_login: '',
        SPH_NAME: '',
        SPH_PRACTICE: '',
        zthis_practice: '',
        SPH_PRACTICE_TYPE: '',
        SPH_SHORTCODE: '',
        SPH_NEW_SITE: '',
        SPH_TIMEZONE_OFFSET: '',
        SPH_COMPONENTS_LIST: '',
        SPH_METRIC1: '',
        SPH_METRIC2: '',
        SPH_METRIC3: '',
        SPH_METRIC4: '',
        SPH_METRIC5: '',
        SPH_METRIC6: '',
        SPH_METRIC7: '',
        SPH_METRIC8: '',
        SPH_METRIC9: '',
        SPH_METRIC10: '',
        SPH_METRIC11: '',
        SPH_METRIC12: '',
        SPH_METRIC13: '',
        SPH_METRIC14: '',
        SPH_SUPER_PRACTICE: '',
        SPH_MASTER_PRACTICE: '',
        USING_NEW_DASHBOARD: 'true',
        SPH_CLIENTVIEW_MODAL: '',
        zthis_login: '',
        this_name: '',
        this_username: '',
        SPH_RETURN: ''
    }
    return requestData
}

async function postToNewDashboardLink(extraData, destination) {
    var requestData = {}
    if(store.getters['currentUser/isUserLoggedIn']) {
        requestData = await getDefaultRequestData(destination)
    }
    else {
        requestData = await getLogoutRequestData()
    }
    requestData = {...requestData, ...extraData}
    return axios({
        method: 'post',
        url: `../include/NewDashboardLink.asp`,
        data: qs.stringify(requestData),
        headers: {
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
        }
    })
}

/*
This function is used to link to the old dashboard. When navigating to the old dashboard call this function
and pass in the desired url to redirect to. This function will set the nessesary session variables then
redirect the user to the desired destination url. 

The parameter newWindow is optional and is of the form:
newWindow: {
    name: "the name of the new window"
    width: the width of the new window
    height: the height of the new window
}
If this parameter is set then the destination url will open in a new window. If this parameter is left
empty then the current screen will be redirected to the destination url.

If there are errors detected the user will instead be redirected to the old dashboard login page. 
*/
export const redirectToOldPracticeDashboard = async function (destinationUrl, newWindow = null, extraData = {}) {
    try {
        postToNewDashboardLink(extraData, destinationUrl)
            .then(function (response) {
                console.log('Successful Response received from NewDashboardLink: ', response)
                if (!newWindow) {
                    console.log(`Redirecting to ${destinationUrl} in same window`)
                    window.location.href = destinationUrl
                } else {
                    console.log(`Opening ${destinationUrl} in new window`)
                    var windowParams = `width=${newWindow.width}, height=${newWindow.height}`
                    window.open(destinationUrl, newWindow.name, windowParams);
                }
            }).catch(function (error) {
                console.log(`Session data update unsuccessful: ${error}. Redirecting to index.asp for new login`)
                window.location.href = `https://${window.location.hostname}/portal/home/healthtrac/index.asp`
            })
    } catch (ex) {
        console.log('Error Linking to old dashboard: ' + ex)
        console.log('Redirecting to index.asp for new login')
        window.location.href = `https://${window.location.hostname}/portal/home/healthtrac/index.asp`
    }
}


/*
This function is used to post data to the old dashboard.
Parameters:
    -destinationUrl: The url to which data should be posted
    -parameters: The parameters to post to the destination.
Return:
    -The response recieved from the old manage area
*/
export const queryOldDashboard = async function (destinationUrl, parameters) {
    try {
        await postToNewDashboardLink(null, destinationUrl)
        parameters = {
            ...parameters,
            CSRFToken: getCookie('xcsrf_token'),
        }
        return axios({
            method: 'post',
            url: destinationUrl,
            data: qs.stringify(parameters),
            headers: {
                'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
            }
        }).then(function (response) {
            return response
        })
    } catch (err) {
        throw err
    }
}


/*
This function is used to sync the new admin dash and the old manage area. It updates the old manage area with the current state of the new admin dash, such as:
    -currently pinned user
    -currently logged in user
    -current practice
    -current master practice
    ...
*/
export const syncDashboards = async function (destination) {
    postToNewDashboardLink(null, destination)
}
